export default __webpack_public_path__ + "static/media/050.b2ba55da.jpg";